import { AfterContentInit, AfterViewInit, Component, ContentChildren, Input, OnInit, QueryList } from '@angular/core';
import { CustomTabComponent } from '../custom-tap/custom-tab.component';
import { TranslocoService } from '@jsverse/transloco';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-default-container-tabs',
  standalone: false,
  templateUrl: './default-container-tabs.component.html',
  styleUrl: './default-container-tabs.component.scss'
})
export class DefaultContainerTabsComponent implements AfterContentInit, AfterViewInit {
  private subs = new Subscription();

  constructor(private translocoService: TranslocoService) { }
  ngAfterViewInit(): void {
    this.subs.unsubscribe();
  }

  @ContentChildren(CustomTabComponent,  { descendants: true }) tabs!: QueryList<CustomTabComponent>;

  @Input({ required: true }) customHeadersEnabled!: boolean;
  @Input() reverseTabs : boolean | undefined;

  ngAfterContentInit() {
    console.log('after init');

    if (this.customHeadersEnabled) {

      this.tabs.forEach((tab, index) => {
        if (!tab.headerTemplate) {

          // NOTE: customHeadersEnabled is REQUIRED!

          this.translocoService.load(this.translocoService.getDefaultLang() || 'it').subscribe(() => {
            const errorMessage = this.translocoService.translate('errors.tabHeaderRequired', { index: 1 });
            console.error('Mensaje traducido después de cargar:', errorMessage);
          });

        }
      });
    }
  }

}
